import React, {createContext, useContext, useState} from 'react'
import PropTypes from 'prop-types'

const LoginContext = createContext()

export const LoginProvider = ({children}) => {
    const [email, setEmail] = useState('')

    return <LoginContext.Provider value={{email, setEmail}}>{children}</LoginContext.Provider>
}

export const useLoginContext = () => useContext(LoginContext)

LoginProvider.propTypes = {
    children: PropTypes.elementType
}
